<template>
    <div class="flex border-b border-gray-400 pb-4">
        <input-radio-multi
            class="mt-4 flex-1"
            name="property_type_class"
            :value="property.property_type_class"
            :options="types"
            :wrap="true"
            :nullable="true"
            :read_only="read_only"
        />
    </div>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        types: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
